<vs-select vsInput [value]="selectedKey" (valueChanges)="select($event)">
  <li *ngFor="let option of options" vs-select-option [value]="option.key">{{ option.label }}</li>
</vs-select>
